import Backbone from 'backbone'
import findByIdsFactory from 'scoreboard/charts/model/find-by-ids-factory'

const findByBreakdownId = findByIdsFactory({
	idAttr: 'breakdownId',
	tempIdAttr: 'breakdownTempId'
})

const ChartDesignerSortSettings = Backbone.Model.extend({
	findSortByValueRange: function ({ id, tempId }) {
		return findByBreakdownId({
			id,
			tempId,
			collection: this.get('sortByValueRanges')
		})
	}
})

export default ChartDesignerSortSettings

ChartDesignerSortSettings.__filename__ = 'charts/model/chart-designer-sort-settings.js'
